import { unpublishPublishedStory as unpublishPublishedStoryEndpoint } from 'admin/resources';
import { UNPUBLISH_PUBLISHED_STORY } from 'admin/constants/actions';
import { StoryFacade } from 'utils/facades/story-facade';
import { createThunkAction } from 'admin/actions/helpers';
import { getStory } from 'admin/actions/story/get-story';
import { catchUpStory } from 'admin/actions/story/catch-up-story';
import { flushStoryEditorSave } from 'admin/actions/story/flush-story-editor-save';
import { toast } from 'admin/components/common/MessageContainer/toast';
import { isEditOperationsSave } from 'admin/utils/story-save-mechanism';

export const unpublishPublishedStory = createThunkAction<void, any>({
	type: UNPUBLISH_PUBLISHED_STORY,
	payloadCreator: async (params, { getState, dispatch }) => {
		const { version, storyEditor } = getState();

		if (!storyEditor.story) return { success: false };

		const Story = new StoryFacade(storyEditor.story, version.current);
		const { storyId } = Story;

		// The reload below replaces the local story: save pending edits first, or autosave would drop them.
		const { success } = await dispatch(flushStoryEditorSave());
		if (isEditOperationsSave && !success) {
			toast.error('Changes are not saved yet. Try unpublishing again.');
			return { success: false };
		}
		await dispatch(catchUpStory(storyId));
		await unpublishPublishedStoryEndpoint.params({ storyId }).send();
		dispatch(getStory({ storyId }));

		return { success: true };
	},
});
